(function() {
    'use strict';

    angular.module('product', [
            'ui.router',

            'product.constants',
            'product.services'
        ])
        .config(uiRouting);

    uiRouting.$inject = ['$stateProvider', 'userPermissionsConst', 'categoryPermissionsConst', 'productPermissionsConst', 'packagePermissionsConst', 'productParameterPermissionsConst', 'productOptionGroupPermissionsConst', 'productOptionPermissionsConst', 'exclusionPermissionsConst', 'discountPermissionsConst'];

    function uiRouting($stateProvider, userPermissionsConst, categoryPermissionsConst, productPermissionsConst, packagePermissionsConst, productParameterPermissionsConst, productOptionGroupPermissionsConst, productOptionPermissionsConst, exclusionPermissionsConst, discountPermissionsConst) {
        $stateProvider
            .state('layout.category', {
                abstract: true,
                url: '/categories',
                data: {
                    title: 'Kategorie',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.category.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/category-list/category-list.html',
                        controller: 'CategoryListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: categoryPermissionsConst.view
                }
            })
            .state('layout.category.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/category-create/category-create.html',
                        controller: 'CategoryCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: categoryPermissionsConst.add
                }
            })
            .state('layout.category.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/category-update/category-update.html',
                        controller: 'CategoryUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: categoryPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.product', {
                abstract: true,
                url: '/products',
                data: {
                    title: 'Produkty',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.product.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/product-list/product-list.html',
                        controller: 'ProductListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productPermissionsConst.view
                }
            })
            .state('layout.product.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/product-create/product-create.html',
                        controller: 'ProductCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productPermissionsConst.add
                }
            })
            .state('layout.product.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/product-update/product-update.html',
                        controller: 'ProductUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.package', {
                abstract: true,
                url: '/packages',
                data: {
                    title: 'Grupy pakowania',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.package.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/package-list/package-list.html',
                        controller: 'PackageListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: packagePermissionsConst.view
                }
            })
            .state('layout.package.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/package-create/package-create.html',
                        controller: 'PackageCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: packagePermissionsConst.add
                }
            })
            .state('layout.package.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/package-update/package-update.html',
                        controller: 'PackageUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: packagePermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.productParameter', {
                abstract: true,
                url: '/product-parameters',
                data: {
                    title: 'Parametry produktów',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.productParameter.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/product-parameter-list/product-parameter-list.html',
                        controller: 'ProductParameterListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productParameterPermissionsConst.view
                }
            })
            .state('layout.productParameter.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/product-parameter-create/product-parameter-create.html',
                        controller: 'ProductParameterCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productParameterPermissionsConst.add
                }
            })
            .state('layout.productParameter.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/product-parameter-update/product-parameter-update.html',
                        controller: 'ProductParameterUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productParameterPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.productOptionGroup', {
                abstract: true,
                url: '/product-option-group',
                data: {
                    title: 'Grupy opcji',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.productOptionGroup.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/option-group-list/group-list.html',
                        controller: 'ProductOptionGroupListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productOptionGroupPermissionsConst.view
                }
            })
            .state('layout.productOptionGroup.create', {
                url: '/create',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/option-group-create/group-create.html',
                        controller: 'ProductOptionGroupCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productOptionGroupPermissionsConst.add
                }
            })
            .state('layout.productOptionGroup.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/option-group-update/group-update.html',
                        controller: 'ProductOptionGroupUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productOptionGroupPermissionsConst.update
                }
            })
            .state('layout.productOptionGroup.detail', {
                url: '/detail/:pk',
                data: {
                    title: 'Opcje',
                    modelPermission: productOptionPermissionsConst.view
                },
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/option-group-detail/group-detail.html',
                        controller: 'ProductOptionGroupDetailController',
                        controllerAs: 'ctrl'
                    }
                }
            });

        $stateProvider
            .state('layout.productOption', {
                abstract: true,
                url: '/product-option',
                data: {
                    title: 'Lista opcji',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.productOption.create', {
                url: '/create/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/option-create/option-create.html',
                        controller: 'ProductOptionCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productOptionPermissionsConst.add
                }
            })
            .state('layout.productOption.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/option-update/option-update.html',
                        controller: 'ProductOptionUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: productOptionPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.productOptionExclusion', {
                abstract: true,
                url: '/product-option-exclusion',
                data: {
                    title: 'Wykluczenia opcji',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.productOptionExclusion.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/exclusion-list/exclusion-list.html',
                        controller: 'ExclusionListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: exclusionPermissionsConst.view
                }
            })
            .state('layout.productOptionExclusion.create', {
                url: '/create/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/exclusion-create/exclusion-create.html',
                        controller: 'ExclusionCreateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: exclusionPermissionsConst.add
                }
            })
            .state('layout.productOptionExclusion.update', {
                url: '/update/:pk',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/exclusion-update/exclusion-update.html',
                        controller: 'ExclusionUpdateController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: exclusionPermissionsConst.update
                }
            });

        $stateProvider
            .state('layout.discount', {
                abstract: true,
                url: '/discount',
                data: {
                    title: 'Rabaty',
                    permission: userPermissionsConst.user
                }
            })
            .state('layout.discount.list', {
                url: '/list',
                views: {
                    'main@layout': {
                        templateUrl: 'app/product/views/discount-list/discount-list.html',
                        controller: 'DiscountListController',
                        controllerAs: 'ctrl'
                    }
                },
                data: {
                    modelPermission: discountPermissionsConst.view
                }
            });
    }
})();
